import {useSelector} from 'react-redux';


import * as contentSelectors from '../contentSelectors';


function useContentDepartments() {

    return useSelector(contentSelectors.getContentDepartments);
}


export default useContentDepartments;
